import { render, staticRenderFns } from "./CMSPageEditor.vue?vue&type=template&id=4605937b&"
import script from "./CMSPageEditor.vue?vue&type=script&lang=js&"
export * from "./CMSPageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports